<div mat-dialog-title  [ngClass]="data.titleClass">
    <label class="dialogTitle">
        {{data.title}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="dialogContent">
    <br />
    <div [innerHTML]="data.message | linebreaks"></div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialogActionsBtns">
    <button class="openCloseBtn" mat-raised-button [mat-dialog-close] (click)="onConfirmClick()"
        [ngClass]="(data.titleClass === 'dialog-error') ? 'mat-warn' : 'mat-primary'">{{'COMMON_DIALOGS_BTN_LABELS.OK' | translate}}</button>
</mat-dialog-actions>